import React from "react";
import { connect } from "react-redux";

import {Button,Icon,Input,Modal,Form,Row,Col,Radio,InputNumber,Spin} from 'antd';

import "./style.css";
import LayoutWrapper from '../../layouts/LayoutWrapper';
import ReduxComponent from '../ReduxComponent';
import {
	changeRecruitmentSetting,
	selectRecruitmentSetting,
	updateRecruitmentSetting,
} from "../../actions/recruitment-actions";
import recruitmentSettingService from "../../services/Recruitment/recruitment-setting-service";
const webConfig = require ('../../config.json');


class RecruitmentSetting extends ReduxComponent {

	initReload = true;
	moduleName = "recruitment";
	childModuleName = "recruitmentSetting";

	state = {
		currentModalStatus: false,
		currentIndex: false,
		currentData: {},
		currentDataStatus: "unload"
	}

	actions = {
		changeAction: this.props.changeRecruitmentSetting,
		selectAction: this.props.selectRecruitmentSetting,
		updateAction: this.props.updateRecruitmentSetting,
		createAction: recruitmentSettingService.createRecruitmentSetting,
		deleteAction: recruitmentSettingService.deleteRecruitmentSetting,
	}

	setKeywordFilter = value => this.actions.changeAction({keyword: value}, "reload")

	changeKeywordFilter = event => {
		if (!event.target.value) {
			this.actions.changeAction({keyword: ""}, "reload")
		}
	}

	createData = () => this.setState({
		currentModalStatus: true,
		currentDataStatus: "loaded",
		currentData: {
			is_ssl: true,
			is_shared: true
		},
		currentIndex: null,
	})

	updateData = (record, index) => this.setState({
		currentModalStatus: true,
		currentDataStatus: "loaded",
		currentData: record,
		currentIndex: index,
	})

	column = [{
			title: '邮箱类型',
			dataIndex: 'email_type',
			key: 'email_type',
			className: 'table-global-head-short'
		},{
			title: '收件箱',
			dataIndex: 'inbox_address',
			key: 'inbox_address',
			className: 'table-global-head-short'
		}, {
			title: '邮箱密码',
			dataIndex: 'email_password',
			key: 'email_password',
			className: 'table-global-head-short'
		}, {
			title: '收件箱服务器',
			dataIndex: 'inbox_server',
			key: 'inbox_server',
			className: 'table-global-head'
		}, {
			title: '是否使用安全协议SSL',
			dataIndex: 'is_ssl',
			key: 'is_ssl',
			className: 'table-global-head',
			render: text => text ? "是" : "否"
		}, {
			title: '是否共享',
			dataIndex: 'is_shared',
			key: 'is_shared',
			className: 'table-global-head',
			render: text => text ? "是" : "否"
		}, {
			title: '端口',
			dataIndex: 'port',
			key: 'port',
			className: 'table-global-head'
		}, {
			title: '操作',
			dataIndex: 'actions',
			key: 'actions',
			className: 'table-global-head',
			render: (text, record, index) => {
				return this.props.access.recruitmentSetting.u_value && 
					<span>
						<Button icon="edit" size="small"
							className="row-action-btn"
							onClick={this.updateData.bind(this, record, index)}>编辑</Button>
					</span>
				
			} 
		}
	];

	render() {
		return (
			<div className="app-module-item">
				<Modal width="1000px"
					visible={this.state.currentModalStatus}
					title="简历库"
					destroyOnClose={true}
					onCancel={this.toggleCurrentModal.bind(this, false)}
					onOk={this.publicSubmit} >
					<div className="app-modal-item">
					{(() => {
						switch (this.state.currentDataStatus) {
							case "reload":
							case "loaded":
								return (
									<Form onSubmit={this.publicSubmit} className="login-form" layout="inline">
									<Row>
										<Col span={12}>
											<div style={{marginBottom:"15px"}}>
												<Form.Item label="邮箱类型">
													{this.props.form.getFieldDecorator('email_type', {
														rules: [{ required: true, message: '请输入邮箱类型' }],
														initialValue: "POP3"
													})(<Input disabled style={{width:"240px"}} />)}
												</Form.Item>
											</div>
										</Col>
										<Col span={12}>
											<div style={{marginBottom:"15px"}}>
												<Form.Item label="收件箱">
													{this.props.form.getFieldDecorator('inbox_address', {
														rules: [{ required: true, message: '请输入收件箱' }],
														initialValue: this.state.currentData.inbox_address
													})(<Input style={{width:"240px"}} />)}
												</Form.Item>
											</div>
										</Col>
										<Col span={12}>
											<div style={{marginBottom:"15px"}}>
												<Form.Item label="邮箱密码">
													{this.props.form.getFieldDecorator('email_password', {
														rules: [{ required: true, message: '请输入邮箱密码' }],
														initialValue: this.state.currentData.email_password
													})(<Input style={{width:"240px"}} />)}
												</Form.Item>
											</div>
										</Col>
										<Col span={12}>
											<div style={{marginBottom:"15px"}}>
												<Form.Item label="端口">
													{this.props.form.getFieldDecorator('port', {
														rules: [{ required: true, message: '请输入端口' }],
														initialValue: this.state.currentData.port
													})(<InputNumber min={1} max={65535} style={{width:"240px"}} />)}
												</Form.Item>
											</div>
										</Col>
										<Col span={12}>
											<div style={{marginBottom:"15px"}}>
												<Form.Item label="收件箱服务器">
													{this.props.form.getFieldDecorator('inbox_server', {
														rules: [{ required: true, message: '请输入收件箱服务器' }],
														initialValue: this.state.currentData.inbox_server
													})(<Input style={{width:"240px"}} />)}
												</Form.Item>
											</div>
										</Col>
										<Col span={12}>
											<div style={{marginBottom:"15px"}}>
												<Form.Item label="是否使用SSL">
													{this.props.form.getFieldDecorator('is_shared', {
														rules: [{ required: true, message: '请输入是否使用SSL' }],
														initialValue: this.state.currentData.is_shared
													})(
													<Radio.Group style={{width:"240px",textAlign:"left"}}>
														<Radio.Button value={true}>是</Radio.Button>
														<Radio.Button value={false}>否</Radio.Button>
													</Radio.Group>
													)}
												</Form.Item>
											</div>
										</Col>
										<Col span={12}>
											<div style={{marginBottom:"15px"}}>
												<Form.Item label="是否共享">
													{this.props.form.getFieldDecorator('is_ssl', {
														rules: [{ required: true, message: '请输入是否共享' }],
														initialValue: this.state.currentData.is_ssl
													})(
													<Radio.Group style={{width:"240px",textAlign:"left"}}>
														<Radio.Button value={true}>是</Radio.Button>
														<Radio.Button value={false}>否</Radio.Button>
													</Radio.Group>
													)}
												</Form.Item>
											</div>
										</Col>
									</Row>
									</Form>)
							case "error":
								return (
									<div style={{textAlign:'center', margin: '100px 0px'}}>
										{webConfig.httpFetchErrorInformation}
									</div>);
							case "loading":
							case "unload":
								return (
									<div style={{textAlign:'center', margin: '100px 0px'}}>
										<Spin size="large" />
									</div>);
							default :
								return null;
						}
					})()}
					</div>
				</Modal>
				<div style={{marginBottom: "20px"}}>
					{this.props.access.recruitmentSetting.c_value && <div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<Button type="primary" onClick={this.createData}>
							<Icon type="plus-circle-o" />
							<span>新增</span>
						</Button>
					</div>}
					{this.props.access.recruitmentSetting.d_value && <div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<Button type="primary" onClick={this.publicDelete}>
							<Icon type="delete" />
							<span>批量删除</span>
						</Button>
					</div>}
					<div className="colAction" style={{float:"right", margin:"0px 10px 10px 0px"}}>
						<Input.Search
							placeholder="关键字"
							onSearch={this.setKeywordFilter}
							onChange={this.changeKeywordFilter}
							style={{ width: 200 }}
							defaultValue={null}
							enterButton />
					</div>
					<div style={{clear: "both"}}></div>
				</div>
				<div>{this.publicTableView()}</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		recruitment: state.recruitment
	}
}

const mapDispatchToProps = {
	changeRecruitmentSetting,
	selectRecruitmentSetting,
	updateRecruitmentSetting,
}
RecruitmentSetting = Form.create()(RecruitmentSetting);

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(RecruitmentSetting));







// WEBPACK FOOTER //
// ./src/routes/Recruitment/RecruitmentSetting.js